// src/hooks/useCurrentRoute.js
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isTokenValid } from '../services/api';

export const useCurrentRoute = () => {
  const location = useLocation();
  const [routeInfo, setRouteInfo] = useState({});

  useEffect(() => {
    const getCurrentRouteInfo = () => {
      const pathname = location.pathname;
      const search = location.search;
      const hash = location.hash;

      // Get user info from single localStorage key
      const userInfo = (() => {
        try {
          return JSON.parse(localStorage.getItem('user') || '{}');
        } catch {
          return {};
        }
      })();

      const isLoggedIn = isTokenValid() && !!localStorage.getItem('user');
      const role = userInfo.RoleName || userInfo.roleName || 'Unknown';

      // Determine route type
      let routeType = 'unknown';
      if (pathname === '/' || pathname === '/login') {
        routeType = 'login';
      } else if (pathname === '/frontoffice') {
        routeType = 'frontoffice';
      } else if (pathname === '/frontoffice-new') {
        routeType = 'frontoffice-new';
      } else if (pathname === '/backoffice') {
        routeType = 'backoffice';
      } else if (pathname === '/logout') {
        routeType = 'logout';
      }

      return {
        pathname,
        search,
        hash,
        routeType,
        isLoggedIn,
        role,
        userInfo,
        fullUrl: `${pathname}${search}${hash}`
      };
    };

    setRouteInfo(getCurrentRouteInfo());
  }, [location]);

  return routeInfo;
};

// Utility function to log current route info
export const logCurrentRoute = () => {
  const userInfo = (() => {
    try {
      return JSON.parse(localStorage.getItem('user') || '{}');
    } catch {
      return {};
    }
  })();

  const info = {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    href: window.location.href,
    isLoggedIn: isTokenValid() && !!localStorage.getItem('user'),
    role: userInfo.RoleName || userInfo.roleName || null,
    user: userInfo
  };

  console.group('🔍 Current Route Info');
  console.table(info);
  console.groupEnd();

  return info;
};
